import styled, { css } from 'styled-components'
import { semiBold, regular, bold } from './fonts'

export const Container = styled.div`
  height: 100%;
  right: 0;
  top: 0;
  width: 0;
  position: fixed;
  background: #fff;
  z-index: 99999999999999;
  overflow-x: hidden;
  box-shadow: 17px 0 55px rgba(68, 5, 22, 0.15);
  transition: 0.5s;
`

export const Content = styled.div`
  padding-top: 35px;
  padding-bottom: 45px;
  padding-right: 10px;
  .custom-cross-icon {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    img {
      width: 25px;
      height: 25px;
      align-self: flex-end;
      resize: contain;
    }
  }
`

export const MobileItem = styled.div`
  display: flex;
  height: 26px;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) =>
    props.active ? 'rgb(249, 247, 249)' : 'transparent'};
  padding: 0 10px;
  cursor: pointer;
  border-radius: 7px;
`

export const ItemText = styled.div`
  font-family: ${(props) => (props.active ? semiBold : regular)};
  font-size: 13px;
  color: #102e4c !important;
  a {
    color: #102e4c !important;
  }
`

export const ItemCount = styled.div`
  font-size: 13px;
  font-family: ${(props) => (props.active ? semiBold : regular)};
  color: #102e4c;
`

export const Separator = styled.div`
  height: 24px;
  width: calc(120% + 40px);
  background: #f4f4f4;
`

export const Language = styled.div`
  width: 100%;
  padding: 10px 0;
  padding-left: 40px;
  font-family: ${semiBold};
  font-size: 18px;
  color: #102e4c;
  cursor: pointer;
`

export const AccordionSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 10px;
`

export const AccordionTitle = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  outline: none;
  padding-top: 5px;
  padding-bottom: 10px;
  transition: background-color 0.2s ease;

  .title {
    padding: 10px 40px;
    padding-bottom: 10px;
  }

  p {
    color: #102e4c;
    font-family: ${semiBold} !important;
    font-size: 17px;
  }

  .active {
    border-top-right-radius: 40px;
    border-bottom-right-radius: 40px;
    background: var(--grey-2, #FAFAFA);
    transition: transform 0.3s ease-in-out;
    p {
      font-family: ${bold} !important;
      font-size: 17px;
    }
  }
`

export const AccordionContent = styled.div`
  background-color: white;
  border-top: ${(props) => (props.hideBar ? 'none' : '1.5px solid #dedede')};
  margin-bottom: ${(props) =>
    props.hideBar &&
    !props.active &&
    '-20px'}; // To reduce bottom margin only for accordions without bar and inactive
  transition: max-height 0.3s ease;
  overflow: hidden;
`

export const RotateIcon = styled.img`
  width: 12px;
  margin-left: auto;
  transition: transform 0.3s ease;
  ${(props) =>
    props.active &&
    css`
      transform: rotate(90deg);
    `}
`

export const AccordionItems = styled.div`
  padding-top: 10px;
  padding-left: 15px;
  padding-right: 25px;
  padding-left: 30px;
`
